export const TopupSorting = {
  ByLastName: 'lastName',
  ByAvailableToTopupAmount: 'availableToTopUpAmount'
};
